import { Layer, Source } from 'react-map-gl';
import useSvgImages from '../../utils/useSvgImages';
import { currentMarkerId, defaultSymbolLayerLayoutProps, getLayerBeforeId } from '../../utils/layers';
import useMap from '../../hooks/useMap';
import currentSvg from '../../utils/svgDefinitions/currentSvg';

const sourceId = 'current-marker';
const svgDefinitions = [currentSvg];

type CurrentMarkerProps = {
  latitude: number;
  longitude: number;
  mapId?: string;
};

const CurrentMarker = ({ latitude, longitude, mapId }: CurrentMarkerProps) => {
  const map = useMap(mapId);
  const { imagesAreLoaded } = useSvgImages(svgDefinitions, mapId);

  if (!imagesAreLoaded) {
    return null;
  }

  return (
    <Source
      id={sourceId}
      type="geojson"
      data={{
        type: 'Point',
        coordinates: [longitude, latitude]
      }}
    >
      <Layer
        id={currentMarkerId}
        source={sourceId}
        beforeId={getLayerBeforeId(map, currentMarkerId)}
        type="symbol"
        layout={{
          ...defaultSymbolLayerLayoutProps,
          'icon-image': currentSvg.name,
          // All maps that use the current marker currently want to always show the marker.
          // Add a prop to control this if it needs to change.
          'icon-allow-overlap': true
        }}
      />
    </Source>
  );
};

export default CurrentMarker;
